'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { useIsMounted } from 'usehooks-ts';

import { useRouter } from '@/i18n/routing';

import styles from './listing-not-found.module.scss';

export default function ListingNotFound() {
  const router = useRouter();
  const isMounted = useIsMounted();

  const listingDetailTranslate = useTranslations('listing.detail');

  useEffect(() => {
    setTimeout(() => {
      router.push('/');
    }, 2000);
  }, [isMounted, router]);

  return (
    <p className={styles.listingNotFound}>{listingDetailTranslate('no-listing')}</p>
  );
}
